import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';
import { SettingsService } from './@core/services/settings.service';

export class BetaFeatureFormlyExtension implements FormlyExtension {
    constructor(private settingsService: SettingsService) { }

    prePopulate(field: FormlyFieldConfig) {
        // const enabledFeatures = this.settingsService.getEnabledFeatures(); Maybe to implment in future!!

        const betaFeature: boolean = field.props?.betaFeature;

        // Check if the global beta mode is enabled
        const isBetaModeEnabled = this.settingsService.isBetaMode();

        // Hide field if `betaFeature` is true and beta mode is disabled
        if (betaFeature == true && !isBetaModeEnabled) {
            field.hide = true;
        }
    }
}

export function betaFeatureExtension(settingsService: SettingsService) {
    return {
        extensions: [{
            name: 'betaFeature',
            extension: new BetaFeatureFormlyExtension(settingsService)
        }],
    };
}